import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchMyUserDetails, fetchWalletStatement, imageBaseUrl, makeRechargeRequest } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";

import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { grey10, linearTopGradient } from "../../constants/colors";
import FullPageLoader from "../../components/FullPageLoader";
import PageHeader from "../../components/PageHeader";
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5";
import LoadMore from "../../components/LoadMore";
import { convertToK } from "../../utils/utils";
import ListEmptyText from "../../components/ListEmptyText";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import MyModal from "../../components/MyModal";
import InputField from "../../components/InputField";
import Button from "../../components/Button";
import SecondaryButton from "../../components/SecondaryButton";

export default function UserWallet() {
  pageTitle("Wallet");
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.appSlice.userData?.id);
  const settings = useSelector((state) => state.appSlice.settings);
  const [start, setStart] = useState(0);
  const [userDetail, setUserDetail] = useState();
  const [statements, setStatements] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(true);

  const [money, setMoney] = useState("");
  const [upiRef, setUpiRef] = useState("");
  const [showMoneyInputModal, setShowMoneyInputModal] = useState(false);
  const [showUpiImageModal, setShowUpiImageModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const fetchUserDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchMyUserDetails, { user_id: userId })
      .then((res) => {
        setUserDetail(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchWalletStatementListFromServer = () => {
    axiosInstance
      .post(fetchWalletStatement, {
        user_id: userId,
        start: start,
        count: 10,
      })
      .then((res) => {
        if (start == 0) {
          setStatements(res.data.data);
        } else {
          setStatements((prev) => [...prev, res.data.data]);
        }
        setStart(res.data.data.length + start);
        if (res.data.data.length < 10) {
          setShowLoadMore(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchUserDetail();
    fetchWalletStatementListFromServer();
  }, []);

  function formatDateTime(input) {
    const date = new Date(input);
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = date.toLocaleString("en-US", options).replace(",", "");
    const [weekday, day, month, year, time] = formattedDate.split(" ");
    return `${weekday}, ${day} ${month}, ${year} : ${time}`;
  }

  // Pay Modal
  const handleMoneyInputSubmit = () => {
    if (money.length === 0) {
      toast.error("Money cannot be empty or lesser than 1");
      return;
    }
    setShowMoneyInputModal(false);
    setShowUpiImageModal(true);
  };
  const handleUpiRefNumberSubmit = () => {
    if (upiRef.length <= 10) {
      toast.error("Please enter a valid UPI Ref no.");
      return;
    }
    axiosInstance
      .post(makeRechargeRequest, {
        user_id: userId,
        amount: money,
        upi_ref: upiRef,
      })
      .then((res) => {
        toast.success(res.data.message);
        // Close all modals
        setShowMoneyInputModal(false);
        setShowUpiImageModal(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  // Pay Modal Ends Here

  return (
    <>
      <Section topMd={20} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading && !statements ? (
          <FullPageLoader />
        ) : (
          <Wrapper className="content-wrapper px-3">
            <CommonMobileHeader canBack={true} title={"Wallet"} />
            <div className="row">
              <div className="col-md-6">
                <div className="rounded py-3 px-3">
                  <div className="d-flex align-items-center shadow justify-content-between py-3 px-4 rounded gd-left-right text-white fw-bold">
                    {userDetail && userDetail?.wallet && <strong className="text-white fs-5 fw-normal pr-3 text-white">{convertToK(userDetail?.wallet)}</strong>}
                    <div className="d-flex gap-2">
                      <button type="button" className="wltBtn" onClick={() => setShowMoneyInputModal(true)}>
                        Add
                      </button>
                      <button type="button" className="wltBtn">
                        Withdraw
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 g-2">
                <p className="fs-normal text-black">Statement</p>
                {statements.length === 0 && <ListEmptyText text={"No Statements Available."} />}
                {statements.map((statement) => (
                  <div key={statement.id} className={`px-2 py-2 d-flex gap-2 fs-normal align-items-center text-black statementItem ${statement.type == 1 ? "bg-danger-surface" : "bg-success-surface"}`}>
                    {statement.type == 1 ? <IoRemoveCircle color="red" size={24} /> : <IoAddCircle color="green" size={24} />}
                    <div className="d-flex flex-column gap-1">
                      <div className="d-flex gap-1 justify-content-start">
                        {statement.transaction_id?.slice(0, 16)}..<span className={`${statement.type == 0 ? "text-success" : "text-danger"} fs-sm `}>{statement.type == 1 ? "PURCHASE" : "DEPOSIT"}</span>
                      </div>
                      <span className="text-muted fs-sm">{formatDateTime(statement.created_at)}</span>
                    </div>
                    <div className="ml-auto text-muted fw-bold">
                      <span>{`${settings.currency}${statement.amount}`}</span>
                    </div>
                  </div>
                ))}
                {<LoadMore visible={showLoadMore} loading={loading} onLoadMoreClick={fetchWalletStatementListFromServer} />}
              </div>
            </div>
          </Wrapper>
        )}
        <MyModal
          isOpen={showMoneyInputModal}
          onClose={() => {
            setShowMoneyInputModal(false);
            setShowUpiImageModal(false);
          }}
        >
          <h4 className="mt-2">Enter Money</h4>
          <InputField value={money} placeholder={"Enter amount"} name="money" onChange={(e) => setMoney(e.target.value)} />
          <SecondaryButton title="Submit" onClick={handleMoneyInputSubmit} />
        </MyModal>
        <MyModal
          isOpen={showUpiImageModal}
          onClose={() => {
            setShowMoneyInputModal(false);
            setShowUpiImageModal(false);
          }}
          modalContainerStyle={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
        >
          <img src="/images/images/qrcode.jpeg" style={{ maxHeight: "450px", margin: "0 auto", display: "flex", justifyContent: "center", alignItems: "center" }} />
          <h4 className="mt-2">Enter Ref No</h4>
          <InputField inputType={"text"} value={upiRef} placeholder={"Enter UPI Ref Number..."} name="upi_ref" onChange={(e) => setUpiRef(e.target.value)} />
          <SecondaryButton title="Submit" onClick={handleUpiRefNumberSubmit} loading={submitting} />
        </MyModal>
      </Section>
    </>
  );
}

const Wrapper = styled.div`
  border-radius: 12px;
  .wltBtn {
    outline: none;
    border: none;
    background-color: #ffffff16;
    color: #fff;
    width: 95px;
    font-size: 0.9rem;
    padding: 4px 8px 4px 8px;
    border-radius: 6px;
  }
  @media screen and (min-width: 768px) {
  }
`;
